/* eslint-disable no-useless-escape */
import { imsLoader, JJ_Edit_icon, JJ_Close_icon, JJ_Trash_icon, JJ_Share_icon, JJ_eye_icon } from "../../assets";
import { Component } from "react";
import Button from "../Button";
import './BookmarkpopUpMyLinks.css';
import ApiServices from "../../utils/apiServices";
import RenameBookmarkPopup from "./RenameBookmarkPopUp";
import GenAIRenameBookmarkPopUp from "../GenAIPopUp/GenAIRenameBookmarkPopUp"
import trackingService from "../../services/trackingService";
import ConfirmMessagePopUpModal from "../PopUp/ConfirmMessagePopUpModal"
import moment from 'moment';
import { Popover } from 'react-tiny-popover';
import { Modal } from "react-bootstrap";

import { Link } from "react-router-dom";



class BookmarkPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isManage: false,
      apiResponse: [],
      bookmarkName: '',
      error: '',
      isContinue: false,
      searchQuery: '',
      showRenamePop: false,
      itemtoBeRenamedName: '',
      itemtoBeRenamedID: '',
      itemtoBeRenamedSearch: '',
      confirmMessageContent: '',
      confirmMessageShowModal: false,
      confirmMessageIndex: -1,
      bsconfirmMessageContent: '',
      bsconfirmMessageShowModal: false,
      bsconfirmMessageIndex: -1,
    };
  }
  async componentDidMount() {
    let username = JSON.parse(localStorage.getItem('username')).toLowerCase();
    await this.getMyBookmarksById();
    // let service = new ApiServices();
    // let apiRes = await service.getMyBookmarksById(username);
    // apiRes = apiRes.sort(function (a, b) { return new Date(b.added_on).getTime() - new Date(a.added_on).getTime() })
    // console.log("apiRes", apiRes)
    // this.setState({
    //   apiResponse: apiRes,
    //   searchQuery: window.location.search,
    //   isLoaded: true
    // })
    if (this.props.isfromUserProfile) {
      this.setState({ isManage: true })
    }
  }
  getMyBookmarksById = async () => {
    let username = JSON.parse(localStorage.getItem('username')).toLowerCase();
    let service = new ApiServices();
    let apiRes = await service.getMyBookmarksById(username);
    apiRes = apiRes.sort(function (a, b) { return new Date(b.added_on).getTime() - new Date(a.added_on).getTime() })
    this.setState({
      apiResponse: apiRes,
      searchQuery: window.location.search,
      isLoaded: true
    })
  }
  showConfirmMessage = (message, index) => {
    this.setState({
      confirmMessageContent: message,
      confirmMessageShowModal: true,
      confirmMessageIndex: index
    })
  }

  confirmHandler = async () => {
    const { confirmMessageIndex } = this.state;
    let username = JSON.parse(localStorage.getItem('username')).toLowerCase();
    let bookmarkName = this.state.apiResponse[confirmMessageIndex].bookmark_name;
    let service = new ApiServices();
    await service.deleteBookmark(username, bookmarkName)
    this.setState({
      isLoaded: false,
      confirmMessageContent: "",
      confirmMessageShowModal: false,
      confirmMessageIndex: -1
    }, async () => {
      let apiRes = await service.getMyBookmarksById(username);
      apiRes = apiRes.sort(function (a, b) { return new Date(b.added_on).getTime() - new Date(a.added_on).getTime() })
      this.setState({
        apiResponse: apiRes,
        isLoaded: true
      })
    })
  }

  closeAlertMessage = () => {
    this.setState({
      confirmMessageContent: "",
      confirmMessageShowModal: false,
      confirmMessageIndex: -1
    })
  }

  bsshowConfirmMessage = (message, index) => {
    this.setState({
      bsconfirmMessageContent: message,
      bsconfirmMessageShowModal: true,
      bsconfirmMessageIndex: index
    })
  }

  bsconfirmHandler = async () => {
    const { bsconfirmMessageIndex } = this.state;
    await this.handelBookmarkRemoveFromHome(bsconfirmMessageIndex);
    this.bscloseAlertMessage();
  }

  bscloseAlertMessage = () => {
    this.setState({
      bsconfirmMessageContent: "",
      bsconfirmMessageShowModal: false,
      bsconfirmMessageIndex: -1
    })
  }
  viewBookmark = (index) => {
    let url;
    if (window.location.pathname === '/ReferencesUsed') {
      url = `${window.location.origin}/ReferencesUsed${this.state.apiResponse[index].search_property}`
      window.open(url, '_blank');
    }
    else {
      url = `${window.location.origin}/results${this.state.apiResponse[index].search_property}&isDisableAiOverview=true`
    }
    window.open(url, '_blank');
  }
  shareBookmark = (index) => {
    let downloadurl = window.location.pathname === '/ReferencesUsed' ? `/ReferencesUsed${this.state.apiResponse[index].search_property}` : `/results${this.state.apiResponse[index].search_property}`
    let mailUrl = window.location.origin + downloadurl
    let bookmarkName = this.state.apiResponse[index].bookmark_name
    bookmarkName = encodeURIComponent(bookmarkName);
    let mailbody = `Bookmark Name: ${bookmarkName}%0D%0DURL:${mailUrl.replace(/&/g, '\%26').replace(/%20/g, '\+')}%0D%0DTo create your own bookmark, follow these instructions:%0D%0D
    1. Click on the link above to run the bookmark on iMedical Search.%0D 
    2. Click the 'Bookmarks' icon from the search results screen.%0D 
    3. For the Bookmark Name option, enter a name of your choosing for the bookmark.%0D 
    4. Click the Save my bookmark button.%0D%0DTo manage all your bookmarks, access the same 'Bookmarks' icon from a search results screen.  
`
    window.open(`mailto:?Subject=iMS Search - '${bookmarkName}' Bookmark&body=${mailbody}`)
  }
  deleteBookmark = async (index) => {
    this.showConfirmMessage("Are you sure to delete this Bookmark?", index);
  }

  handleRename = (id, name, property) => {
    this.setState({
      showRenamePop: true,
      itemtoBeRenamedName: name,
      itemtoBeRenamedID: id,
      itemtoBeRenamedSearch: property
    })
  }

  handleRenameClose = (status) => {
    this.setState({
      showRenamePop: status,
      isLoaded: false
    }, async () => {
      let username = JSON.parse(localStorage.getItem('username')).toLowerCase()
      let service = new ApiServices();
      let apiRes = await service.getMyBookmarksById(username);
      apiRes = apiRes.sort(function (a, b) { return new Date(b.added_on).getTime() - new Date(a.added_on).getTime() })
      this.setState({
        apiResponse: apiRes,
        isLoaded: true
      })
    })
  }

  handelAddBookmark = () => {
    let params = new URLSearchParams(this.state.searchQuery)
    let query = params.get('query');
    let filter = params.get('filter');
    const ts = new trackingService();
    ts.indexTrackingData(
      localStorage.getItem("userdisplayName"),
      localStorage.getItem("wwid"),
      localStorage.getItem("username"),
      localStorage.getItem("function"),
      localStorage.getItem("region"),
      localStorage.getItem("userproducts"),
      localStorage.getItem("doctypepref"),
      localStorage.getItem("sid"),
      localStorage.getItem("deviceType"),
      localStorage.getItem("deviceOS"),
      localStorage.getItem("browserName"),
      localStorage.getItem("browserVersion"),
      localStorage.getItem("jnjDepartment"),
      localStorage.getItem('companyname'),
      ``,
      "",
      window.location.href,
      query,
      filter
    );
  }
  handelBookmarkAddToHome = async (bookmarkId) => {
    this.setState({ isLoaded: false })
    let service = new ApiServices();
    let wwid = JSON.parse(localStorage.getItem('wwid'));
    await service.insertBookmarkToHomePage(bookmarkId, wwid)
      .then(async (response) => {
        await this.getMyBookmarksById();
        if (this.props.updateBMAddForHome) {
          await this.props.updateBMAddForHome();
        }
      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.setState({ isLoaded: true })
      });
  }
  handelBookmarkRemoveFromHome = async (_id) => {
    this.setState({ isLoaded: false })
    let service = new ApiServices();
    await service.deleteBookmarkFromHomePage(_id)
      .then(async (response) => {
        await this.getMyBookmarksById();
        if (this.props.updateBMAddForHome) {
          await this.props.updateBMAddForHome();
        }
      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.setState({ isLoaded: true })
      });
  }

  render() {
    const { confirmMessageContent, confirmMessageShowModal, bsconfirmMessageContent, bsconfirmMessageShowModal } = this.state;
    if (this.props.customWidth < 600) {
      return (
        <Modal
          show={this.props.showModal}
          size="lg md sm xs"
          centered
          aria-labelledby="contained-modal-title-vcenter"
          dialogClassName="popup-transition"
          scrollable={true}
        >
          <div className="gen-ai-recommended-main-pop-up-container">
            <div className="gen-ai-recommended-home-mylink-pop-up-close-button">
              <div className="gen-ai-recommended-home-mylink-pop-up-wrapper-close-icon">
                <img onClick={() => {
                  this.setState({ showPop: false });
                  this.props.handleClose(false);
                }} title="Close" className="reading-list-action-text" src={JJ_Close_icon} alt="" />
              </div>
            </div>
            <Modal.Body scrollable={true} className="gen-ai-recommended-main-pop-up-table-modal-body">
              <div>
                {this.state.isLoaded ? <>
                  {this.state.apiResponse.length > 0 ?
                    <span>
                      <table className="gen-ai-recommended-main-pop-up-table-manage-personal-alerts-wrapper">
                        <tr>
                          <th className="gen-ai-recommended-main-pop-up-table-column-linkname">Link Name</th>
                          <th className="gen-ai-recommended-main-pop-up-table-column">Actions</th>
                        </tr>
                        <tbody>
                          {this.state.apiResponse.map((item, index) => {
                            return (
                              <tr key={item.bookmark_id}>
                                <td className="gen-ai-recommended-main-pop-up-table-row-td-link-name">{item.bookmark_name}</td>
                                <td className="gen-ai-recommended-main-pop-up-table-row-td">
                                  <img onClick={() => this.viewBookmark(index)} title="View" className="reading-list-action-text" src={JJ_eye_icon} alt="" />
                                  <span className="gen-ai-recommended-home-mylink-pop-up-table-divider"></span>
                                  <img onClick={() => this.shareBookmark(index)} title="Share" className="reading-list-action-text" src={JJ_Share_icon} alt="" />
                                  <span className="gen-ai-recommended-home-mylink-pop-up-table-divider"></span>
                                  <img onClick={e => this.handleRename(item.bookmark_id, item.bookmark_name, item.search_property)} title="Rename" className="reading-list-action-text" src={JJ_Edit_icon} alt="" />
                                  <span className="gen-ai-recommended-home-mylink-pop-up-table-divider"></span>
                                  <img onClick={e => this.deleteBookmark(index)} title="Delete" className="reading-list-action-text" src={JJ_Trash_icon} alt="" />
                                </td>
                              </tr>)
                          })}
                        </tbody>
                      </table>
                    </span>
                    : <><span className="no-bookmark-heading">No Links.</span>
                      <br />
                      <span className="no-bookmark-text">It looks like you don't have any bookmarks yet. To create a bookmark, please run a search and click on 'Bookmark' icon from the results screen.</span>
                    </>}
                </> :
                  <div className="gen-ai-recommended-main-pop-up-table-main-loader-div" >
                    <img className="gen-ai-recommended-main-pop-up-table-main-loader" src={imsLoader} alt="Loading Data" />
                  </div>
                }
              </div>
            </Modal.Body>
          </div>
          {this.state.showRenamePop &&
            <>
              <RenameBookmarkPopup showModal={this.state.showRenamePop} handleClose={(status) => this.handleRenameClose(status)} bookmarkName={this.state.itemtoBeRenamedName} bookmarkId={this.state.itemtoBeRenamedID} searchProperty={this.state.itemtoBeRenamedSearch} apiResponse={this.state.apiResponse} customWidth={this.props.customWidth} />
              <div className="savemodal-outer-wrapper"></div>
            </>
          }
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeAlertMessage()} handleConfirm={() => this.confirmHandler()} />}
        </Modal>
      );
    }
    else if (this.props.customWidth >= 600 && this.props.customWidth <= 1000) {
     return (
        <div className="gen-ai-recommended-home-mylink-pop-up">
          <div className="gen-ai-recommended-home-mylink-pop-up-fade-background" />
          <Popover
            isOpen={true}
            positions={['right', 'top']}
            align={'start'}
            reposition={false}
            scrollable
            containerStyle={{
              position: 'fixed',
              zIndex: '999',
              backgroundColor: '#ffffff',
              width: '30rem',
              borderRadius: '20px'
            }}
            content={(positions, align) => (
              <div className="gen-ai-recommended-home-mylink-pop-up-popover-div">
                <div className="gen-ai-recommended-home-mylink-pop-up-close-button pop-up-close-button-margin-bottom">
                  <div className="gen-ai-recommended-home-mylink-pop-up-wrapper-close-icon">
                    <img onClick={() => {
                      this.setState({ showPop: false });
                      this.props.handleClose(false);
                    }} title="Close" className="reading-list-action-text" src={JJ_Close_icon} style={{ zIndex: "10" }} alt="" />
                  </div>
                </div>
                <div className="gen-ai-recommended-home-mylink-pop-up-table-wrapper">
                  {this.state.isLoaded ? <>
                    {this.state.apiResponse.length > 0 ? <>
                      <div className="gen-ai-common-popup__inner">
                        <div className="gen-ai-common-popup__header-row" role="row">
                          <div className="gen-ai-common-popup__header gen-ai-common-popup__header--name">Link Name</div>
                          <div className="gen-ai-common-popup__header gen-ai-common-popup__header--actions" aria-hidden>
                            Actions
                          </div>
                        </div>
                        <ul className="gen-ai-common-popup__--home-mylink-list" role="list">
                          {this.state.apiResponse.map((item, index) => (
                            <li className="gen-ai-common-popup__row" key={item.bookmark_id} role="listitem">
                              <div className="gen-ai-common-popup__cell--home-mylink-name">
                                <Link
                                  to="#"
                                  className="gen-ai-recommended-home-mylink-pop-up-table-row-td-link"
                                  title={item.bookmark_name}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.viewBookmark(index);
                                  }}
                                >
                                  {item.bookmark_name}
                                </Link>
                                {/* <span className="gen-ai-common-popup__link-name">{item.notebooklist_name}</span> */}
                              </div>
                              <div className="gen-ai-common-popup__cell gen-ai-common-popup__cell--actions">
                                <div className="gen-ai-common-popup__actions">
                                  <button
                                    type="button"
                                    title="Share"
                                    className="gen-ai-common-popup__icon-btn"
                                    aria-label={`More actions for ${item.search_name}`}
                                    onClick={() => this.shareBookmark(index)}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M13.8605 8.40489C14.0232 8.26539 14.1046 8.19564 14.1344 8.11264C14.1606 8.03979 14.1606 7.96011 14.1344 7.88726C14.1046 7.80426 14.0232 7.73451 13.8605 7.59501L8.21354 2.7546C7.93339 2.51447 7.79332 2.3944 7.67473 2.39146C7.57167 2.3889 7.47322 2.43418 7.40809 2.5141C7.33315 2.60606 7.33315 2.79055 7.33315 3.15953V6.02304C5.91008 6.27201 4.60764 6.99312 3.63975 8.07586C2.58453 9.25629 2.00082 10.7839 2 12.3673V12.7753C2.69954 11.9325 3.57295 11.251 4.56042 10.7772C5.43101 10.3596 6.37212 10.1122 7.33315 10.047V12.8404C7.33315 13.2093 7.33315 13.3938 7.40809 13.4858C7.47322 13.5657 7.57167 13.611 7.67473 13.6084C7.79332 13.6055 7.93339 13.4854 8.21354 13.2453L13.8605 8.40489Z" stroke="#eb1600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                  </button>
                                  <button
                                    type="button"
                                    className="gen-ai-common-popup__icon-btn"
                                    onClick={e => this.handleRename(item.bookmark_id, item.bookmark_name, item.search_property)}
                                    title="Rename">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g clip-path="url(#clip0_1761_5055)">
                                        <path d="M1.91725 12.0771C1.94788 11.8014 1.96319 11.6636 2.0049 11.5347C2.0419 11.4205 2.09417 11.3117 2.16031 11.2114C2.23485 11.0983 2.33291 11.0003 2.52902 10.8042L11.3329 1.99998C12.0693 1.2636 13.2631 1.2636 13.9995 1.99998C14.7358 2.73636 14.7358 3.93027 13.9995 4.66665L5.19559 13.4708C4.99948 13.6669 4.90142 13.765 4.78838 13.8396C4.68809 13.9057 4.57932 13.958 4.46503 13.995C4.33621 14.0367 4.19838 14.052 3.92273 14.0826L1.66656 14.3333L1.91725 12.0771Z" stroke="#eb1600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1761_5055">
                                          <rect width="15.9994" height="16" rx="4" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </button>
                                  <button
                                    type="button"
                                    title="Delete"
                                    className="gen-ai-common-popup__icon-btn"
                                    aria-label={`Delete ${item.search_name}`}
                                    onClick={e => this.deleteBookmark(index)}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M10.6664 3.99992V3.46659C10.6664 2.71985 10.6664 2.34648 10.521 2.06126C10.3932 1.81038 10.1892 1.60641 9.93837 1.47858C9.65317 1.33325 9.27981 1.33325 8.5331 1.33325H7.46647C6.71976 1.33325 6.34641 1.33325 6.0612 1.47858C5.81033 1.60641 5.60636 1.81038 5.47854 2.06126C5.33322 2.34648 5.33322 2.71985 5.33322 3.46659V3.99992M2 3.99992H13.9996M12.6663 3.99992V11.4666C12.6663 12.5867 12.6663 13.1467 12.4483 13.5746C12.2566 13.9509 11.9506 14.2569 11.5743 14.4486C11.1465 14.6666 10.5865 14.6666 9.4664 14.6666H6.53317C5.41311 14.6666 4.85308 14.6666 4.42527 14.4486C4.04896 14.2569 3.74301 13.9509 3.55127 13.5746C3.33329 13.1467 3.33329 12.5867 3.33329 11.4666V3.99992" stroke="#eb1600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                  </button>

                                  {item.shortcutid ? <button
                                    type="button"
                                    title="Remove From Home Screen"
                                    className="gen-ai-common-popup__icon-btn"
                                    aria-label={`Delete ${item.search_name}`}
                                    onClick={e => this.bsshowConfirmMessage("Are you sure you want to remove this bookmark from home screen?", item.shortcutid)
                                      //this.handelBookmarkRemoveFromHome(item.shortcutid)
                                    }>
                                    {/* <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M10.6664 3.99992V3.46659C10.6664 2.71985 10.6664 2.34648 10.521 2.06126C10.3932 1.81038 10.1892 1.60641 9.93837 1.47858C9.65317 1.33325 9.27981 1.33325 8.5331 1.33325H7.46647C6.71976 1.33325 6.34641 1.33325 6.0612 1.47858C5.81033 1.60641 5.60636 1.81038 5.47854 2.06126C5.33322 2.34648 5.33322 2.71985 5.33322 3.46659V3.99992M2 3.99992H13.9996M12.6663 3.99992V11.4666C12.6663 12.5867 12.6663 13.1467 12.4483 13.5746C12.2566 13.9509 11.9506 14.2569 11.5743 14.4486C11.1465 14.6666 10.5865 14.6666 9.4664 14.6666H6.53317C5.41311 14.6666 4.85308 14.6666 4.42527 14.4486C4.04896 14.2569 3.74301 13.9509 3.55127 13.5746C3.33329 13.1467 3.33329 12.5867 3.33329 11.4666V3.99992" stroke="#eb1600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg> */}
                                    <svg width="16" height="16" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.005 512.005" fill="#000000">
                                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                      <g id="SVGRepo_iconCarrier">
                                        <g>
                                          <g>
                                            <g>
                                              <path style={{ fill: "#eb1600" }} d="M511.99,378.909c0-66.75-50.083-122.564-114.458-131.677v-55.014l18.531,15.549 c4.36,3.27,9.811,5.45,14.171,5.45c6.54,0,11.991-2.18,15.261-6.541c7.631-9.811,6.54-22.892-2.18-30.522L239.47,5.011 c-7.631-6.54-19.621-6.54-27.252,0L7.283,176.154c-8.721,7.631-9.811,21.802-2.18,30.522c7.631,8.721,21.802,9.811,30.522,2.18 l19.621-16.482V393.08c0,11.991,9.811,21.802,21.802,21.802h173.964c15.851,55.758,67.587,97.017,129.078,97.017 C453.126,511.899,513.08,451.944,511.99,378.909z M98.662,155.906L226.389,48.615L354.13,155.8 c-0.129,0.954-0.202,1.925-0.202,2.913v89.614c-59.114,11.439-104.72,62.469-107.754,124.042H98.85V158.713 C98.85,157.761,98.781,156.826,98.662,155.906z M380.091,469.386c-50.144,0-90.477-40.333-90.477-90.477 c0-50.144,40.333-90.477,90.477-90.477c49.054,0,90.477,40.333,90.477,90.477C470.567,429.053,430.234,469.386,380.091,469.386z"></path>
                                              <path style={{ fill: "#eb1600" }} d="M428.054,356.017h-95.927c-11.991,0-21.802,9.811-21.802,21.802 c0,11.991,9.811,21.802,21.802,21.802h95.927c10.901,0,21.802-9.811,21.802-21.802 C449.856,365.828,440.045,356.017,428.054,356.017z"></path>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                  </button> : <button
                                    type="button"
                                    title="Add To Home Screen"
                                    className="gen-ai-common-popup__icon-btn"
                                    aria-label={`Delete ${item.search_name}`}
                                    onClick={e => this.handelBookmarkAddToHome(item.bookmark_id)}>
                                    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.005 512.005" fill="#eb1600">
                                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                      <g id="SVGRepo_iconCarrier">
                                        <g>
                                          <g>
                                            <g>
                                              <path style={{ fill: "#eb1600" }} d="M511.99,378.909c0-66.75-50.083-122.564-114.458-131.677v-55.014l18.531,15.549 c4.36,3.27,9.811,5.45,14.171,5.45c6.54,0,11.991-2.18,15.261-6.541c7.631-9.811,6.54-22.892-2.18-30.522L239.47,5.011 c-7.631-6.54-19.621-6.54-27.252,0L7.283,176.154c-8.721,7.631-9.811,21.802-2.18,30.522c7.631,8.721,21.802,9.811,30.522,2.18 l19.621-16.482V393.08c0,11.991,9.811,21.802,21.802,21.802h173.964c15.851,55.758,67.587,97.017,129.078,97.017 C453.126,511.899,513.08,451.944,511.99,378.909z M98.662,155.906L226.389,48.615L354.13,155.8 c-0.129,0.954-0.202,1.925-0.202,2.913v89.614c-59.114,11.439-104.72,62.469-107.754,124.042H98.85V158.713 C98.85,157.761,98.781,156.826,98.662,155.906z M380.091,469.386c-50.144,0-90.477-40.333-90.477-90.477 c0-50.144,40.333-90.477,90.477-90.477c49.054,0,90.477,40.333,90.477,90.477C470.567,429.053,430.234,469.386,380.091,469.386z"></path>
                                              <path style={{ fill: "#eb1600" }} d="M428.054,356.017h-26.162v-26.162c0-11.991-9.811-21.802-21.802-21.802 c-11.991,0-21.802,9.811-21.802,21.802v26.162h-26.162c-11.991,0-21.802,9.811-21.802,21.802 c0,11.991,9.811,21.802,21.802,21.802h26.162v26.162c0,11.991,9.811,21.802,21.802,21.802c10.901,0,20.712-8.721,21.802-21.802 v-26.162h26.162c10.901,0,21.802-9.811,21.802-21.802C449.856,365.828,440.045,356.017,428.054,356.017z">
                                              </path>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                  </button>}
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </> : <><span className="no-bookmark-heading-mylink-popup">No Links.</span>
                      <br />
                      <span className="no-bookmark-text-mylink-popup">It looks like you don't have any bookmarks yet. To create a bookmark, please run a search and click on 'Bookmark' icon from the results screen.</span>
                    </>}
                  </> :
                    <div className="gen-ai-recommended-main-pop-up-table-main-loader-div" >
                      <img className="gen-ai-recommended-main-pop-up-table-main-loader" src={imsLoader} alt="Loading Data" />
                    </div>
                  }
                </div>
              </div>
            )}>
            <div />
          </Popover>
          {this.state?.showRenamePop &&
            <div>
              <GenAIRenameBookmarkPopUp showModal={this.state.showRenamePop} handleClose={(status) => this.handleRenameClose(status)} bookmarkName={this.state.itemtoBeRenamedName} bookmarkId={this.state.itemtoBeRenamedID} searchProperty={this.state.itemtoBeRenamedSearch} apiResponse={this.state.apiResponse} customWidth={this.props.customWidth} />
              <div className="savemodal-outer-wrapper"></div>
            </div>
          }
          {bsconfirmMessageShowModal && <ConfirmMessagePopUpModal content={bsconfirmMessageContent} showModal={bsconfirmMessageShowModal} handleClose={() => this.bscloseAlertMessage()} handleConfirm={() => this.bsconfirmHandler()} />}
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeAlertMessage()} handleConfirm={() => this.confirmHandler()} />}
        </div>
      );
    }
    else {
      return (
        <div className="gen-ai-recommended-home-mylink-pop-up">
          <div className="gen-ai-recommended-home-mylink-pop-up-fade-background" />
          <Popover
            isOpen={true}
            positions={['right', 'top']}
            align={'start'}
            reposition={false}
            scrollable
            containerStyle={{
              position: 'fixed',
              zIndex: '999',
              backgroundColor: '#ffffff',
              width: '30rem',
              borderRadius: '20px'
            }}
            content={(positions, align) => (
              <div className="gen-ai-recommended-home-mylink-pop-up-popover-div">
                <div className="gen-ai-recommended-home-mylink-pop-up-close-button pop-up-close-button-margin-bottom">
                  <div className="gen-ai-recommended-home-mylink-pop-up-wrapper-close-icon">
                    <img onClick={() => {
                      this.setState({ showPop: false });
                      this.props.handleClose(false);
                    }} title="Close" className="reading-list-action-text" src={JJ_Close_icon} style={{ zIndex: "10" }} alt="" />
                  </div>
                </div>
                <div className="gen-ai-recommended-home-mylink-pop-up-table-wrapper">
                  {this.state.isLoaded ? <>
                    {this.state.apiResponse.length > 0 ? <>
                      <div className="gen-ai-common-popup__inner">
                        <div className="gen-ai-common-popup__header-row" role="row">
                          <div className="gen-ai-common-popup__header gen-ai-common-popup__header--name">Link Name</div>
                          <div className="gen-ai-common-popup__header gen-ai-common-popup__header--actions" aria-hidden>
                            Actions
                          </div>
                        </div>
                        <ul className="gen-ai-common-popup__--home-mylink-list" role="list">
                          {this.state.apiResponse.map((item, index) => (
                            <li className="gen-ai-common-popup__row" key={item.bookmark_id} role="listitem">
                              <div className="gen-ai-common-popup__cell--home-mylink-name">
                                <Link
                                  to="#"
                                  className="gen-ai-recommended-home-mylink-pop-up-table-row-td-link"
                                  title={item.bookmark_name}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.viewBookmark(index);
                                  }}
                                >
                                  {item.bookmark_name}
                                </Link>
                                {/* <span className="gen-ai-common-popup__link-name">{item.notebooklist_name}</span> */}
                              </div>
                              <div className="gen-ai-common-popup__cell gen-ai-common-popup__cell--actions">
                                <div className="gen-ai-common-popup__actions">
                                  <button
                                    type="button"
                                    title="Share"
                                    className="gen-ai-common-popup__icon-btn"
                                    aria-label={`More actions for ${item.search_name}`}
                                    onClick={() => this.shareBookmark(index)}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M13.8605 8.40489C14.0232 8.26539 14.1046 8.19564 14.1344 8.11264C14.1606 8.03979 14.1606 7.96011 14.1344 7.88726C14.1046 7.80426 14.0232 7.73451 13.8605 7.59501L8.21354 2.7546C7.93339 2.51447 7.79332 2.3944 7.67473 2.39146C7.57167 2.3889 7.47322 2.43418 7.40809 2.5141C7.33315 2.60606 7.33315 2.79055 7.33315 3.15953V6.02304C5.91008 6.27201 4.60764 6.99312 3.63975 8.07586C2.58453 9.25629 2.00082 10.7839 2 12.3673V12.7753C2.69954 11.9325 3.57295 11.251 4.56042 10.7772C5.43101 10.3596 6.37212 10.1122 7.33315 10.047V12.8404C7.33315 13.2093 7.33315 13.3938 7.40809 13.4858C7.47322 13.5657 7.57167 13.611 7.67473 13.6084C7.79332 13.6055 7.93339 13.4854 8.21354 13.2453L13.8605 8.40489Z" stroke="#eb1600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                  </button>
                                  <button
                                    type="button"
                                    className="gen-ai-common-popup__icon-btn"
                                    onClick={e => this.handleRename(item.bookmark_id, item.bookmark_name, item.search_property)}
                                    title="Rename">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g clip-path="url(#clip0_1761_5055)">
                                        <path d="M1.91725 12.0771C1.94788 11.8014 1.96319 11.6636 2.0049 11.5347C2.0419 11.4205 2.09417 11.3117 2.16031 11.2114C2.23485 11.0983 2.33291 11.0003 2.52902 10.8042L11.3329 1.99998C12.0693 1.2636 13.2631 1.2636 13.9995 1.99998C14.7358 2.73636 14.7358 3.93027 13.9995 4.66665L5.19559 13.4708C4.99948 13.6669 4.90142 13.765 4.78838 13.8396C4.68809 13.9057 4.57932 13.958 4.46503 13.995C4.33621 14.0367 4.19838 14.052 3.92273 14.0826L1.66656 14.3333L1.91725 12.0771Z" stroke="#eb1600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1761_5055">
                                          <rect width="15.9994" height="16" rx="4" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </button>
                                  <button
                                    type="button"
                                    title="Delete"
                                    className="gen-ai-common-popup__icon-btn"
                                    aria-label={`Delete ${item.search_name}`}
                                    onClick={e => this.deleteBookmark(index)}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M10.6664 3.99992V3.46659C10.6664 2.71985 10.6664 2.34648 10.521 2.06126C10.3932 1.81038 10.1892 1.60641 9.93837 1.47858C9.65317 1.33325 9.27981 1.33325 8.5331 1.33325H7.46647C6.71976 1.33325 6.34641 1.33325 6.0612 1.47858C5.81033 1.60641 5.60636 1.81038 5.47854 2.06126C5.33322 2.34648 5.33322 2.71985 5.33322 3.46659V3.99992M2 3.99992H13.9996M12.6663 3.99992V11.4666C12.6663 12.5867 12.6663 13.1467 12.4483 13.5746C12.2566 13.9509 11.9506 14.2569 11.5743 14.4486C11.1465 14.6666 10.5865 14.6666 9.4664 14.6666H6.53317C5.41311 14.6666 4.85308 14.6666 4.42527 14.4486C4.04896 14.2569 3.74301 13.9509 3.55127 13.5746C3.33329 13.1467 3.33329 12.5867 3.33329 11.4666V3.99992" stroke="#eb1600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                  </button>

                                  {item.shortcutid ? <button
                                    type="button"
                                    title="Remove From Home Screen"
                                    className="gen-ai-common-popup__icon-btn"
                                    aria-label={`Delete ${item.search_name}`}
                                    onClick={e => this.bsshowConfirmMessage("Are you sure you want to remove this bookmark from home screen?", item.shortcutid)
                                      //this.handelBookmarkRemoveFromHome(item.shortcutid)
                                    }>
                                    {/* <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M10.6664 3.99992V3.46659C10.6664 2.71985 10.6664 2.34648 10.521 2.06126C10.3932 1.81038 10.1892 1.60641 9.93837 1.47858C9.65317 1.33325 9.27981 1.33325 8.5331 1.33325H7.46647C6.71976 1.33325 6.34641 1.33325 6.0612 1.47858C5.81033 1.60641 5.60636 1.81038 5.47854 2.06126C5.33322 2.34648 5.33322 2.71985 5.33322 3.46659V3.99992M2 3.99992H13.9996M12.6663 3.99992V11.4666C12.6663 12.5867 12.6663 13.1467 12.4483 13.5746C12.2566 13.9509 11.9506 14.2569 11.5743 14.4486C11.1465 14.6666 10.5865 14.6666 9.4664 14.6666H6.53317C5.41311 14.6666 4.85308 14.6666 4.42527 14.4486C4.04896 14.2569 3.74301 13.9509 3.55127 13.5746C3.33329 13.1467 3.33329 12.5867 3.33329 11.4666V3.99992" stroke="#eb1600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg> */}
                                    <svg width="16" height="16" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.005 512.005" fill="#000000">
                                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                      <g id="SVGRepo_iconCarrier">
                                        <g>
                                          <g>
                                            <g>
                                              <path style={{ fill: "#eb1600" }} d="M511.99,378.909c0-66.75-50.083-122.564-114.458-131.677v-55.014l18.531,15.549 c4.36,3.27,9.811,5.45,14.171,5.45c6.54,0,11.991-2.18,15.261-6.541c7.631-9.811,6.54-22.892-2.18-30.522L239.47,5.011 c-7.631-6.54-19.621-6.54-27.252,0L7.283,176.154c-8.721,7.631-9.811,21.802-2.18,30.522c7.631,8.721,21.802,9.811,30.522,2.18 l19.621-16.482V393.08c0,11.991,9.811,21.802,21.802,21.802h173.964c15.851,55.758,67.587,97.017,129.078,97.017 C453.126,511.899,513.08,451.944,511.99,378.909z M98.662,155.906L226.389,48.615L354.13,155.8 c-0.129,0.954-0.202,1.925-0.202,2.913v89.614c-59.114,11.439-104.72,62.469-107.754,124.042H98.85V158.713 C98.85,157.761,98.781,156.826,98.662,155.906z M380.091,469.386c-50.144,0-90.477-40.333-90.477-90.477 c0-50.144,40.333-90.477,90.477-90.477c49.054,0,90.477,40.333,90.477,90.477C470.567,429.053,430.234,469.386,380.091,469.386z"></path>
                                              <path style={{ fill: "#eb1600" }} d="M428.054,356.017h-95.927c-11.991,0-21.802,9.811-21.802,21.802 c0,11.991,9.811,21.802,21.802,21.802h95.927c10.901,0,21.802-9.811,21.802-21.802 C449.856,365.828,440.045,356.017,428.054,356.017z"></path>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                  </button> : <button
                                    type="button"
                                    title="Add To Home Screen"
                                    className="gen-ai-common-popup__icon-btn"
                                    aria-label={`Delete ${item.search_name}`}
                                    onClick={e => this.handelBookmarkAddToHome(item.bookmark_id)}>
                                    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.005 512.005" fill="#eb1600">
                                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                      <g id="SVGRepo_iconCarrier">
                                        <g>
                                          <g>
                                            <g>
                                              <path style={{ fill: "#eb1600" }} d="M511.99,378.909c0-66.75-50.083-122.564-114.458-131.677v-55.014l18.531,15.549 c4.36,3.27,9.811,5.45,14.171,5.45c6.54,0,11.991-2.18,15.261-6.541c7.631-9.811,6.54-22.892-2.18-30.522L239.47,5.011 c-7.631-6.54-19.621-6.54-27.252,0L7.283,176.154c-8.721,7.631-9.811,21.802-2.18,30.522c7.631,8.721,21.802,9.811,30.522,2.18 l19.621-16.482V393.08c0,11.991,9.811,21.802,21.802,21.802h173.964c15.851,55.758,67.587,97.017,129.078,97.017 C453.126,511.899,513.08,451.944,511.99,378.909z M98.662,155.906L226.389,48.615L354.13,155.8 c-0.129,0.954-0.202,1.925-0.202,2.913v89.614c-59.114,11.439-104.72,62.469-107.754,124.042H98.85V158.713 C98.85,157.761,98.781,156.826,98.662,155.906z M380.091,469.386c-50.144,0-90.477-40.333-90.477-90.477 c0-50.144,40.333-90.477,90.477-90.477c49.054,0,90.477,40.333,90.477,90.477C470.567,429.053,430.234,469.386,380.091,469.386z"></path>
                                              <path style={{ fill: "#eb1600" }} d="M428.054,356.017h-26.162v-26.162c0-11.991-9.811-21.802-21.802-21.802 c-11.991,0-21.802,9.811-21.802,21.802v26.162h-26.162c-11.991,0-21.802,9.811-21.802,21.802 c0,11.991,9.811,21.802,21.802,21.802h26.162v26.162c0,11.991,9.811,21.802,21.802,21.802c10.901,0,20.712-8.721,21.802-21.802 v-26.162h26.162c10.901,0,21.802-9.811,21.802-21.802C449.856,365.828,440.045,356.017,428.054,356.017z">
                                              </path>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                  </button>}
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </> : <><span className="no-bookmark-heading-mylink-popup">No Links.</span>
                      <br />
                      <span className="no-bookmark-text-mylink-popup">It looks like you don't have any bookmarks yet. To create a bookmark, please run a search and click on 'Bookmark' icon from the results screen.</span>
                    </>}
                  </> :
                    <div className="gen-ai-recommended-main-pop-up-table-main-loader-div" >
                      <img className="gen-ai-recommended-main-pop-up-table-main-loader" src={imsLoader} alt="Loading Data" />
                    </div>
                  }
                </div>
              </div>
            )}>
            <div />
          </Popover>
          {this.state?.showRenamePop &&
            <div>
              <GenAIRenameBookmarkPopUp showModal={this.state.showRenamePop} handleClose={(status) => this.handleRenameClose(status)} bookmarkName={this.state.itemtoBeRenamedName} bookmarkId={this.state.itemtoBeRenamedID} searchProperty={this.state.itemtoBeRenamedSearch} apiResponse={this.state.apiResponse} customWidth={this.props.customWidth} />
              <div className="savemodal-outer-wrapper"></div>
            </div>
          }
          {bsconfirmMessageShowModal && <ConfirmMessagePopUpModal content={bsconfirmMessageContent} showModal={bsconfirmMessageShowModal} handleClose={() => this.bscloseAlertMessage()} handleConfirm={() => this.bsconfirmHandler()} />}
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeAlertMessage()} handleConfirm={() => this.confirmHandler()} />}
        </div>
      );
    }
  }
}
export default BookmarkPopUp;
